import React from 'react';

export function InputRevertButton({ title, ...props }) {
    return (
        <button type="button" className="input-revert-button" title={title} {...props}>
            {title && <span className="visually-hidden">{title}</span>}
        </button>
    );
}
